export const API_ROUTE_ORGANIZATION_SETTINGS_BY_KEY =
  '/organizations/:organizationId/settings/:key';
